import './style.scss';
import SettingButton from './SettingButton';
import React from 'react';
import Toggle from 'react-toggle';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import SkillSelector from './SkillSelector';

import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class MembersTeam extends React.Component {
  render() {
    let { membersStore, member, intl } = this.props;
    let { confirm } = membersStore;

    return (
      <Row>
        <Col sm={6}>
          {!membersStore.canManage ? null : (
            <div className="toggle-container">
              <label>
                <h5>{intl.formatMessage({ id: 'customer_support' })}</h5>
              </label>
              <br />
              <Toggle
                checked={member.customer_support_leader}
                onChange={e => {
                  if (confirm())
                    membersStore.handleCustomerSupport(
                      member.id,
                      !member.customer_support_leader
                    );
                }}
              />
            </div>
          )}
        </Col>
        <Col sm={6}>
          <SkillSelector member={member} />
          <div className="role-container">
            <h5>{intl.formatMessage({ id: 'responsability' })}: </h5>
            <h5>{intl.formatMessage({ id: member.scorecard })}</h5>
            &nbsp;&nbsp;
            {!membersStore.canManage ? null : (
              <div id="setting-button-container">
                <SettingButton
                  options="responsibilities"
                  member={member}
                  handle={membersStore.handleResponsibility}
                />
              </div>
            )}
            &nbsp;&nbsp;
            <div className="role-container">
              <h5>{this.props.intl.formatMessage({ id: 'board' })}: </h5>
              <h5>
                {membersStore.getBoard(member.id).map(elem =>
                  `${this.props.intl.formatMessage({
                    id: elem
                  })}, `
                )}
              </h5>
              &nbsp;&nbsp;
              {!membersStore.canManage ? null : (
                <div id="setting-button-container">
                  <SettingButton
                    options="bRoles"
                    member={member}
                    handle={membersStore.handleBoard}
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}
